/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum MarketEntryPathways{
  DirectExportToBusiness=1,
  ExportViaDistributor,
  AttractingVisitors,
  ExportViaOnline,
  Franchising,
  Licensing,
  SupportingAustralianBusinesses,
  Others
}
